import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "react-intl"
import { useDispatch } from "react-redux"
import Api from "../../api/Api"
import { dialogMessages } from "../../i18n/lstrings"
import ForgotPasswordForm from "./ForgotPasswordForm"
import { actions as notifier } from "../../component/notifier"

const ForgotPasswordContainer = ({ onClose }) => {
  const { formatMessage: format } = useIntl()
  const dispatch = useDispatch()

  const onSubmit = (values) => {
    return Api.request("/auth/forgotpassword", values)
      .then(() => {
        const msg = format(dialogMessages.forgotPasswordSuccess, values)
        dispatch(notifier.enqueueSuccess(msg))
      })
      .catch(() => {
        // even if incorrect, display the same message to prevent account deduction attack
        const msg = format(dialogMessages.forgotPasswordSuccess, values)
        dispatch(notifier.enqueueSuccess(msg))
      })
      .finally(() => onClose())
  }

  return <ForgotPasswordForm onSubmit={onSubmit} />
}

ForgotPasswordContainer.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default ForgotPasswordContainer
